import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { IBreadcrumb } from '@lib/models/breadcrumb.model';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { CaseDetail, TaskDetails, ReminderDetails, NotificationDetails } from '../models/calender-case.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CalenderCaseService } from '../services/calender-case.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-calender-details',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    BreadcrumbComponent,
    MatProgressSpinnerModule
  ],
  templateUrl: './calender-details.component.html',
  styleUrl: './calender-details.component.scss'
})
export class CalenderDetailsComponent implements OnInit {

  cases: CaseDetail[] = [];
  tasks: TaskDetails[] = [];
  reminders: ReminderDetails[] = [];
  notifications: NotificationDetails[] = [];
  calendarDate: string = '';
  isCasesExpanded: boolean = true;
  isTasksExpanded: boolean = false;
  isRemindersExpanded: boolean = false;
  isNotificationsExpanded: boolean = false;
  isLoadingAll: boolean = true;

  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([
    { label: 'Calender' },
    { label: 'My Tasks' },
  ]);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private calenderCaseService: CalenderCaseService,

  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.calendarDate = params['date'];
      this.fetchCases();
      this.fetchTasks();
      this.fetchReminders();
      this.fetchNotifications();
    });
  }

  fetchCases(): void {
    this.isLoadingAll = true;
    this.calenderCaseService.fetchCasesByDate(this.calendarDate).subscribe({
      next: (response) => {
        this.cases = response.data;
        console.log('Fetched Cases:', this.cases);
        this.isLoadingAll = false;
      },
      error: (error) => console.error('Error fetching cases:', error),
    });
    this.isLoadingAll = false;
  }

  fetchTasks(): void {
    this.isLoadingAll = true;
    this.calenderCaseService.fetchTasksByDate(this.calendarDate).subscribe({
      next: (response) => {
        if (response.data) {
          this.tasks = response.data.map((task) => ({
            ...task,
            tasksDue: this.formatDate(task.tasksDue),
            tasksDone: this.formatDate(task.tasksDone),
          }));
          console.log('Fetched Tasks:', this.tasks);
          this.isLoadingAll = false;
        } else {
          console.log('No tasks available for the selected date.');
          this.tasks = [];
        }
      },
      error: (error) => console.error('Error fetching tasks:', error),
    });
    this.isLoadingAll = false;
  }

  fetchReminders(): void {
    this.isLoadingAll = true;
    this.calenderCaseService.fetchRemindersByDate(this.calendarDate).subscribe({
      next: (response) => {
        this.reminders = response.data.map((reminders) => ({
          ...reminders,
          remindersDue: this.formatDate(reminders.remindersDue),
          remindersDone: this.formatDate(reminders.remindersDone),
        }));
        console.log('Fetched Reminders:', this.reminders);
        this.isLoadingAll = false;
      },
      error: (error) => console.error('Error fetching reminders:', error),
    });
    this.isLoadingAll = false;
  }

  fetchNotifications(): void {
    this.isLoadingAll = true;
    this.calenderCaseService.fetchNotificationsByDate(this.calendarDate).subscribe({
      next: (response) => {
        this.notifications = response.data.map((notifications) => ({
          ...notifications,
          notificationsDue: this.formatDate(notifications.notificationsDue),
          notificationsDone: this.formatDate(notifications.notificationsDone),
        }));
        console.log('Fetched Notifications:', this.notifications);
        this.isLoadingAll = false;
      },
      error: (error) => console.error('Error fetching Notifications:', error),
    });
    this.isLoadingAll = false;
  }

  toggleCasesExpand(): void {
    this.isCasesExpanded = !this.isCasesExpanded;
  }

  toggleTasksExpand(): void {
    this.isTasksExpanded = !this.isTasksExpanded;
  }

  toggleRemindersExpand(): void {
    this.isRemindersExpanded = !this.isRemindersExpanded;
  }

  toggleNotificationsExpand(): void {
    this.isNotificationsExpanded = !this.isNotificationsExpanded;
  }

  private formatDate(input: string | number | null): string {
    if (!input) {
      return '-';
    }
    if (typeof input === 'number') {
      const date = new Date(input);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-GB', { month: 'short' });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
    }
    if (typeof input === 'string') {
      const validDateString = input.replace('.0', '');
      const date = new Date(validDateString);
      if (!isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-GB', { month: 'short' });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
    }
    return '-';
  }
  goToListOfFiles(caseItem: any): void {
    this.calenderCaseService.navigateToRoute('/dashboard/list-of-files', { caseNumber: caseItem.caseNumber })
  }
  ;
}
